<template lang="pug">
.row(style="padding-bottom:150px")
  .centered-content
    h1.page-header Welcome to the budgee alpha
    h2.page-header To get started check out our alpha videos
    .center-video.elevation-10(style="padding-top: 55.2%")
      iframe(
        width="1120" 
        height="571" 
        src="https://www.youtube.com/embed/MAz_MnYTwd4" 
        frameborder="0"
        modestbranding
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
    h2.page-header
      |This alpha lets you be one of the very first to try out budgee. A new tool for helping you navigate cash flow. It was made with small businesses in mind but can also work well for your personal finance management.
    .arrow
      img(src="@/assets/images/arrow.png")
    .centered-row.text-right
      .left-side
        bw-picture-circles
        .center-video.elevation-10
          iframe(
            width="560" 
            height="278" 
            src="https://www.youtube.com/embed/nOD-nIFF7a8" 
            frameborder="0"
            modestbranding
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
      .right-side
        h1
          .step 1
          |Budgee basics
        p.feature-text Join James / Richard as he goes through the basics of how to use budgee. Log in below and follow along!
        .button-row.feature-text
          a.bw-button.push-button.budgee-button(href="https://budgee-dev.web.app/" target="_blank") 
            img.budgee-logo(src="@/assets/ico-budgee-white.svg" style="margin-right: 10px;")
            |Go to budgee
    .arrow.arrow-right
      img(src="@/assets/images/arrow.png")
    .centered-row.text-left
      .left-side
        h1
          .step 2
          |Become a budgee expert
        p.feature-text Once you have got a handle on the basics, check out our advanced tutorial. You will be an expert in no time!
        .button-row.feature-text
          a.bw-button.push-button.budgee-button(href="https://budgee-dev.web.app/" target="_blank") 
            img.budgee-logo(src="@/assets/ico-budgee-white.svg" style="margin-right: 10px;")
            |Go to budgee
      .right-side
        bw-picture-circles
        .center-video.elevation-10
          iframe(
            width="560" 
            height="278"
            modestbranding
            src="https://www.youtube.com/embed/09CAXZgTUyc" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
    .arrow
      img(src="@/assets/images/arrow.png")
    .centered-row.text-right
      .left-side
        bw-picture-circles
        .center-video.elevation-10
          iframe(
            width="560" 
            height="278" 
            src="https://www.youtube.com/embed/5BZw67UuBEo" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)            
      .right-side
        h1
          .step 3
          |Let us know your thoughts
        p.feature-text As part of the alpha process, we need your feedback. Join Lizzie in this quick and fun video on how to best give your two cents on the budgee Trello board.
        .button-row.feature-text
          a.bw-button.push-button.trello-button(href="https://trello.com/invite/b/f5wjoVtw/4500228868ef44cbae7a32404ce9681f/budgee-alpha-feedback" target="_blank") 
            i.fab.fa-trello(style="padding-right: 10px;")
            |Go to trello
    .arrow.arrow-right
      img(src="@/assets/images/arrow.png")
    .centered-row.text-left
      .left-side
        h1
          .step 4
          |Have a laugh on us
        p.feature-text If you have made it to the end, congratulations and enjoy! Courtesy of Lizzie :)
      .right-side
        bw-picture-circles
        .center-video.elevation-10
          iframe(
            width="560" 
            height="278"
            modestbranding
            src="https://www.youtube.com/embed/i8DluBkBkks" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
</template>

<script>
import BwPictureCircles from "@/components/shared/BwPictureCircles";
export default {
  components: {
    BwPictureCircles
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
.row
  display: flex
  background: white//#f5f7f9
.centered-row
  display: flex
  flex-direction: row
  margin-bottom: 0
  padding-top: 30px
.centered-content
  padding-bottom: 60px
.center-video
  margin: 0 auto 50px
  display: flex
  border: 10px solid white
  border-radius: 3px
  width: 100%
  max-width: 1120px
  background: white
  z-index: 1
  position: relative
  overflow: hidden
  padding-top: 54%
  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    border: 0
h1.page-header
  margin: 0
  padding-top: 50px
  text-align: center
  font-weight: 500
  font-size: 50px
  line-height: 60px
  color: rgba(0,0,0,0.77)
  margin: 25px 0 32px
h2.page-header
  color: rgba(0,0,0,0.67)
  text-align: center
  padding-left: 3px
  line-height: 30px
  margin-bottom: 0
  font-size: 20px
  font-weight: 300
  padding-bottom: 50px
h1, h2, h3, p, iframe
  z-index: 1
  position: relative
h1:not(.page-header)
  font-size: 36px
  line-height: 37px
  font-weight: 600
  color: rgba(0,0,0,0.79)
  margin-bottom: 2px
  text-indent: -72px
  padding-left: 72px
h2:not(.page-header)
  font-size: 22px
  text-align: center
  font-weight: 300
  padding-bottom: 30px
h3
  font-size: 22px
p
  line-height: 30px
.step
  min-width: 50px
  height: 50px
  color: white
  background: grey
  border-radius: 50%
  display: inline-block
  text-align: center
  line-height: 50px
  margin-right: 20px
  text-indent: 0
.left-side, .right-side
  display: flex
  flex-direction: column
  width: 50%
  position: relative
.left-side
  padding-right: 20px
.right-side
  padding-left: 20px
.picture
  margin: 0 auto
  border-radius: 10px
  background: white
  overflow: hidden
  height: 340px
  width: 450px
  box-shadow: 0 6px 6px -3px rgba(0,0,0,.05),0 10px 14px 1px rgba(0,0,0,.05),0 4px 18px 3px rgba(0,0,0,.05) !important
.left-side .picture
  margin-right: 30px
.right-side .picture
  margin-left: 30px
.feature-text
  margin-left: 73px
.spacer
  padding-top: 50px
.arrow
  display: flex
  margin: 0 auto 20px
  z-index: 1
  img
    margin: 0 auto
    height: 120px
    z-index: 1
.arrow-right
  img
    transform: scaleX(-1)
.budgee-button, .trello-button
  align-items: center
  display: flex
  margin-top: 10px
  height: 46px
  z-index: 1
.budgee-button
  width: 195px
  background: #fe8a5b
  img
    height: 26px
  &:hover
    background: #ffa785
  &:active
    background: #ca572a
.trello-button
  width: 170px
  background: #0767A2
  &:hover
    background: #218dd0
  &:active
    background: #114965
  i
    font-size: 20px
.button-row
  display: flex
  flex-direction: row
  align-items: center
  justify-content: flex-end
@media mq-tablet-wide
  .text-right
    flex-direction: column
  .text-left
    flex-direction: column-reverse
  .right-side, .left-side
    width: 100%
    display: flex
    align-items: center
    padding: 0
    margin: 0
    .picture
      margin: 0 0 0 0
  h1, p
    text-align: center
  h1:not(.page-header)
    font-size: 20px
    line-height: 30px
  h2.page-header
    padding-bottom: 50px
  p
    font-size: 16px
    line-height: 26px
    margin-top: 0
  h1.page-header
    padding-top: 20px !important
  .centered-row
    margin-bottom: 100px
  .feature-text
    margin-left: 0
</style>
